export default __webpack_public_path__ + "static/media/Menu_Icon_Summaries.3f557ae9.svg";